import { enumToOptions } from '@app/shared/helpers';
import { WaterfallSectionsErf } from '@app/shared/models/contracts/enums/shared-enums';

export const WATERFALL_SECTION_ERF_OPTIONS = enumToOptions(WaterfallSectionsErf, undefined, true, {
  viewValue: 'Jump to section...',
  value: '',
});
